<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="12"
    viewBox="0 0 16 12"
  >
    <g id="Group_816" data-name="Group 816" transform="translate(-24 -314)">
      <path
        id="Path_373"
        data-name="Path 373"
        d="M23.5,19.667H19V10.5a.5.5,0,0,0-1,0v5.833h-.685L15.747,11.89a1.834,1.834,0,0,0-1.729-1.223H11.834a.5.5,0,0,0-.5.5v3.5h-1.5A1.835,1.835,0,0,0,8,16.5v3a1.168,1.168,0,0,0,1.167,1.167h.2a1.667,1.667,0,0,0,3.266,0h1.4a1.667,1.667,0,0,0,3.266,0h6.2a.5.5,0,1,0,0-1Zm-11.167-8h1.684a.834.834,0,0,1,.786.556l1.451,4.111H13.167a.834.834,0,0,1-.833-.833V11.667ZM11,21a.667.667,0,1,1,.667-.667A.667.667,0,0,1,11,21Zm4.667,0a.667.667,0,1,1,.667-.667A.667.667,0,0,1,15.667,21Z"
        transform="translate(16 304)"
      />
      <g id="Group_814" data-name="Group 814" transform="translate(16 304)">
        <path
          id="Path_374"
          data-name="Path 374"
          d="M22.5,15.333v.5a.5.5,0,0,1-1,0v-.5H20.333a.333.333,0,0,0-.333.333v2.667a.333.333,0,0,0,.333.333h3.333A.333.333,0,0,0,24,18.333V15.666a.333.333,0,0,0-.333-.333Z"
        />
        <path
          id="Path_375"
          data-name="Path 375"
          d="M22.5,11.333v.5a.5.5,0,0,1-1,0v-.5H20.333a.333.333,0,0,0-.333.333v2.667a.333.333,0,0,0,.333.333h3.333A.333.333,0,0,0,24,14.333V11.666a.333.333,0,0,0-.333-.333Z"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: "inventory-icon",
};
</script>

<style scoped></style>
